import { Injectable } from "@angular/core";
import { HttpService } from "./http-service";
import { Router } from "@angular/router";
import { HttpClient,  HttpHeaders} from '@angular/common/http';
import { ToastrService } from "ngx-toastr";
import { map } from "rxjs/operators";
import { Configuracoes } from "../entities/configuracoes";
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from "crypto-js";
@Injectable({
  providedIn: "root",
})
export class CnpjService extends HttpService {
  constructor(
    public router: Router,
    public http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    public toastService: ToastrService
  ) {
    super(http, router, toastService, platformId);
  }


  getCnpjAPIAgilb2b(cnpj: string, callback) {
    cnpj = cnpj.replace(".", "").replace(".", "");
    cnpj = cnpj.replace("/", "");
    cnpj = cnpj.replace("-", "");
    this.showLoading();
    let url = Configuracoes.API + "consultacnpj?cnpj=" + cnpj;
    this.http
      .get(url, this.getHttpOptionsCnpj())
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => {
          callback(resp);
          this.dimissLoading();
        },
        (error) => {
          this.dimissLoading();
          this.toastService.info($localize`Não foi possivel consultar CNPJ`, "", {
            timeOut: 4000,
          });
        }
      );
  }

  getHttpOptionsCnpj() {
    const now = Date.now()
    var header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.getToken(),
      Branch: Configuracoes.API_BRANCH
    });
    return {
      headers: header,
    };
  }

  getToken() {
    return window.localStorage.getItem("token");
  }
}
